import { Injectable } from '@angular/core';
import { Control, DivIcon, FeatureGroup, latLng, Map, MapOptions, Marker, MarkerOptions, tileLayer, TileLayer } from 'leaflet';
import proj4 from 'proj4';
import { Subject } from 'rxjs';
import Layers = Control.Layers;

@Injectable()

export class LeafletMapService {

  public mapLayerStandard: TileLayer = tileLayer('https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/standaard/EPSG:3857/{z}/{x}/{y}.png', {
    detectRetina: true,
    attribution: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>',
    minZoom: 6,
    maxZoom: 19,
  });

  public mapLayerSatellite: TileLayer = tileLayer('https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_orthoHR/EPSG:3857/{z}/{x}/{y}.png', {
    detectRetina: true,
    attribution: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>',
    minZoom: 6,
    maxZoom: 19,
  });

  public mapOptions: MapOptions = {
    layers: [this.mapLayerStandard],
    zoom: 8,
    center: latLng(51.80, 4.94)
  };

  public baseMaps = {
    'Achtergrond kaart': this.mapLayerStandard,
    'Luchtfoto kaart': this.mapLayerSatellite
  };

  public markerLayer: FeatureGroup = new FeatureGroup();
  public mapContainer: Map = null;
  public singleMarker: Marker = null;

  private defaultZoomed: number = 17;

  public zoomChanged: Subject<number> = new Subject<number>();

  constructor() {
  }

  init(mapContainer: Map): void {
    this.mapContainer = mapContainer;
    this.mapContainer.addLayer(this.markerLayer);
    this.mapContainer.addControl(new Layers(this.baseMaps));

    // on the initial app load with map view open, a map centre is off, reset it
    if (mapContainer !== null) {
      setTimeout(() => {
        if (this.mapContainer !== null) {
          this.mapContainer.invalidateSize();
        }
      }, 100);
    }

    this.mapContainer.on('zoomend', (): void => this.zoomChanged.next(this.mapContainer.getZoom()));
  }

  marker(iconColor: string = null): MarkerOptions {
    return {
      icon: new DivIcon({
        html: '<div class="leaflet-custom-marker-pin"' + (iconColor ? 'style="color:' + iconColor + '"' : '') + '></div>',
        iconSize: [24, 36],
        iconAnchor: [12, 36],
      }),
      draggable: false,
    };
  }

  updateMarker(coords: [number, number], zoom: number = null): void {
    if (this.singleMarker) {
      this.singleMarker.setLatLng({lat: coords[0], lng: coords[1]});
    } else {
      this.singleMarker = new Marker({lat: coords[0], lng: coords[1]}, this.marker('single'));
      this.markerLayer.addLayer(this.singleMarker);
    }

    if (this.mapContainer !== null && this.mapContainer !== undefined) {
      this.mapContainer.setView(coords, zoom ?? this.defaultZoomed);
    }
  }

  clear(clearContainer: boolean = false): void {
    this.markerLayer.clearLayers();
    this.singleMarker = null;
    if (document.querySelector('.legend-toggle') !== null) {
      document.querySelector('.legend-toggle').removeAllListeners('click');
    }

    if (clearContainer && this.mapContainer !== null) {
      this.mapContainer = null;
    }
  }

  convertLatLngToNewRd(coords: [number, number]): [number, number] {
    proj4.defs('EPSG:28992',
      '+proj=sterea +lat_0=52.1561605555556 +lon_0=5.38763888888889 ' +
      '+k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel ' +
      '+towgs84=565.4171,50.3319,465.5524,1.9342,-1.6677,9.1019,4.0725 ' +
      '+units=m +no_defs +type=crs'
    );
    return proj4('EPSG:4326', 'EPSG:28992', coords);
  }

  convertNewRdToLatLng(coords: [number, number]): [number, number] {
    return proj4('EPSG:28992', 'EPSG:4326', coords);
  }
}
